export const extractApiErrors = (resError) => {
    let errors = [{title: 'Error!', detail: 'Oops, something went wrong!'}];

    if(resError && resError.data && resError.data.errors){
        errors = resError.data.errors;
    }
    return errors;
}